import { useRef } from "react";
import Alerts from "../../util/Alerts";
import { Card, CardBody, CardTitle } from "reactstrap";
import BlkFormik from "../../util/BlkFormik";
import { useUser } from "../../custom-hooks/useUser";
import { useHistory } from "react-router-dom";
import { HOME_PATH } from "../../components/Navbars/navbar.constants";
import { ReportForm } from "./components/ReportForm";
import { reportSchema } from "./schemas/report.schema";

export const Reports = () => {
    const alert = useRef();
    const { adminReportes } = useUser();
    const history = useHistory();
    const today = new Date();
    const fromDate = new Date("2000/01/01");

    if (!adminReportes) history.push(HOME_PATH);

    return (
        <>
            <Alerts ref={alert} />
            <Card>
                <CardBody>
                    <CardTitle tag="h4">Reportes</CardTitle>
                    <div className="container d-flex flex-column gap-4 mt-4">
                        <BlkFormik validationSchema={reportSchema} validateOnChange validateOnMount>
                            <ReportForm
                                title="Reporte de cartera"
                                description="Fecha de vencimiento"
                                requestPath="/reports/portfolio"
                                initialFromValue={fromDate}
                                initialToValue={new Date(today.getFullYear() + 1, today.getMonth() + 1, 0)}
                                initialCutOffDateValue={today}
                            />
                        </BlkFormik>
                        <BlkFormik validationSchema={reportSchema} validateOnChange validateOnMount>
                            <ReportForm
                                title="Reporte de comisiones"
                                description="Corte por fecha de pago"
                                requestPath="/reports/commission"
                                initialFromValue={fromDate}
                                initialToValue={new Date(today.getFullYear(), today.getMonth() + 1, 0)}
                                initialCutOffDateValue={today}
                            />
                        </BlkFormik>
                    </div>
                </CardBody>
            </Card>
        </>
    );
};
